// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/pages/Home.css */
.home-page {
    max-width: 1200px;
    margin: 0 auto;
  }
  
  .hero-section {
    text-align: center;
    margin-bottom: 48px;
    padding: 48px 24px;
    background: linear-gradient(135deg, #7209b7 0%, #f72585 100%);
    border-radius: 12px;
    color: white;
  }
  
  .hero-content h1 {
    font-size: 32px;
    margin-bottom: 16px;
  }
  
  .hero-content p {
    font-size: 18px;
    max-width: 600px;
    margin: 0 auto;
  }
  
  .upload-section,
  .processing-section,
  .results-section {
    margin-bottom: 48px;
  }
  
  .upload-section h2,
  .processing-section h2,
  .results-section h2 {
    text-align: center;
    margin-bottom: 24px;
    color: var(--primary-color);
  }
  `, "",{"version":3,"sources":["webpack://./src/pages/Home.css"],"names":[],"mappings":"AAAA,uBAAuB;AACvB;IACI,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,6DAA6D;IAC7D,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;EAChB;;EAEA;;;IAGE,mBAAmB;EACrB;;EAEA;;;IAGE,kBAAkB;IAClB,mBAAmB;IACnB,2BAA2B;EAC7B","sourcesContent":["/* src/pages/Home.css */\n.home-page {\n    max-width: 1200px;\n    margin: 0 auto;\n  }\n  \n  .hero-section {\n    text-align: center;\n    margin-bottom: 48px;\n    padding: 48px 24px;\n    background: linear-gradient(135deg, #7209b7 0%, #f72585 100%);\n    border-radius: 12px;\n    color: white;\n  }\n  \n  .hero-content h1 {\n    font-size: 32px;\n    margin-bottom: 16px;\n  }\n  \n  .hero-content p {\n    font-size: 18px;\n    max-width: 600px;\n    margin: 0 auto;\n  }\n  \n  .upload-section,\n  .processing-section,\n  .results-section {\n    margin-bottom: 48px;\n  }\n  \n  .upload-section h2,\n  .processing-section h2,\n  .results-section h2 {\n    text-align: center;\n    margin-bottom: 24px;\n    color: var(--primary-color);\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
